import { useCallback, useContext } from "react";
import { GlobalContext } from "../components/GlobalContext";
import useCaptions from "./captions";
import { initialCaptionsState, initialMeetingState } from "../types";

export const useMeeting = () => {
  const context = useContext(GlobalContext);
  return [context.meeting, context.setMeeting] as const;
};

export const useLeaveMeeting = () => {
  const [, setMeeting] = useMeeting();
  const [, setCaptions] = useCaptions();

  return useCallback(() => {
    setMeeting(initialMeetingState);
    setCaptions(initialCaptionsState);
  }, [setMeeting, setCaptions]);
};
